/* ==============================================================================================
   assets/scheda-pallini-fratelli.js - TRE MODULI INDIPENDENTI IN UN FILE SOLO (una richiesta HTTP)
   Caricato da layout/theme.liquid con defer su tutte le pagine. File nostro, non appartiene a Prestige.
   Ogni modulo e' una IIFE a se', senza variabili condivise. Il nome del file e' quello del primo
   modulo; gli altri file lo citano cosi' ("modulo galleria di scheda-pallini-fratelli.js").
   Per saltare a un modulo cercare il suo titolo in maiuscolo:
   1. CAMBIO COLORE SUL POSTO   - schede in griglia (snippets/scheda-pallini-fratelli.liquid)
   2. UNA SCHEDA PER FAMIGLIA   - griglie su piu' pagine e contatore (sections/conta-famiglie-d5.liquid)
   3. GALLERIA NELLA SCHEDA     - schede in griglia E riga del carrello (snippets/scheda-galleria.liquid,
                                  snippets/carrello-riga.liquid, assets/carrello.js)
   ============================================================================================== */

/* ----------------------------------------------------------------------------------------------
   CAMBIO COLORE SUL POSTO NELLE SCHEDE IN GRIGLIA (prodotti-fratello)
   Markup: snippets/scheda-pallini-fratelli.liquid. CSS: assets/scheda-pallini-fratelli.css.

   Cosa fa: al click su un pallino colore di una scheda (a.color-swatch dentro .scheda-pallini-fratelli)
   NON segue il link ma sostituisce l'intera scheda (<product-card>) con quella del fratello, che il
   server ha gia' renderizzato dentro un <template class="scheda-fratello" data-handle="..."> nella
   scheda stessa. I template degli altri colori, piu' uno nuovo con la scheda appena tolta, passano
   nella scheda inserita: si puo' cambiare colore avanti e indietro senza limiti.

   Scelte:
   - delega sul document, cosi' funziona anche per schede caricate dopo (paginazione, "carica altri",
     caroselli, risultati di ricerca);
   - Ctrl/Cmd/Shift+click e tasto centrale restano al browser (aprire il prodotto in un'altra scheda);
   - prima di sostituire, l'immagine principale del fratello viene precaricata con gli stessi
     srcset/sizes, cosi' la scheda nuova compare gia' con la foto (attesa massima 700 ms, poi si
     sostituisce comunque); al passaggio del mouse sul pallino la precarica parte in anticipo;
   - l'ordine dei pallini della scheda nuova viene riallineato a quello della scheda tolta: si sposta
     solo l'anello, i pallini non saltano;
   - alla scheda inserita viene tolto reveal-on-scroll: Prestige lo usa per un'animazione di comparsa
     al caricamento, e una scheda inserita dopo resterebbe a opacita' 0;
   - un click mentre una sostituzione e' in corso viene ignorato (data-cambio-in-corso).
   ---------------------------------------------------------------------------------------------- */
(function () {
  'use strict';

  var SEL_PALLINO = '.scheda-pallini-fratelli a.color-swatch';

  function handleDaUrl(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function trovaTemplate(scheda, handle) {
    if (!handle || !window.CSS || !CSS.escape) return null;
    return scheda.querySelector('template.scheda-fratello[data-handle="' + CSS.escape(handle) + '"]');
  }

  function precarica(template) {
    var img = template.content.querySelector('.product-card__image--primary');
    if (!img) return Promise.resolve();
    var i = new Image();
    var sizes = img.getAttribute('sizes');
    var srcset = img.getAttribute('srcset');
    if (sizes) i.sizes = sizes;
    if (srcset) i.srcset = srcset;
    i.src = img.getAttribute('src') || '';
    var caricata = i.decode
      ? i.decode().catch(function () {})
      : new Promise(function (r) { i.onload = i.onerror = r; });
    return Promise.race([caricata, new Promise(function (r) { setTimeout(r, 700); })]);
  }

  function schedaInTemplate(scheda) {
    var t = document.createElement('template');
    t.className = 'scheda-fratello';
    t.setAttribute('data-handle', scheda.getAttribute('handle') || '');
    var clone = scheda.cloneNode(true);
    clone.removeAttribute('data-cambio-in-corso');
    clone.removeAttribute('data-galleria-attiva');
    clone.querySelectorAll('template.scheda-fratello').forEach(function (x) { x.remove(); });
    /* la scheda ripartira' dalla foto 1 (elemento nuovo, scrollLeft 0): puntini allineati */
    clone.querySelectorAll('.scheda-galleria__punto').forEach(function (p, i) { p.classList.toggle('is-active', i === 0); });
    t.content.appendChild(clone);
    return t;
  }

  function riallineaPallini(scheda, ordine) {
    var box = scheda.querySelector('.scheda-pallini-fratelli');
    if (!box || !ordine.length) return;
    var pallini = Array.prototype.slice.call(box.querySelectorAll('a.color-swatch'));
    pallini.sort(function (a, b) {
      var ia = ordine.indexOf(handleDaUrl(a.getAttribute('href')));
      var ib = ordine.indexOf(handleDaUrl(b.getAttribute('href')));
      if (ia < 0) ia = ordine.length;
      if (ib < 0) ib = ordine.length;
      return ia - ib;
    });
    pallini.forEach(function (a) { box.appendChild(a); });
  }

  function cambiaColore(scheda, pallino) {
    var handle = handleDaUrl(pallino.getAttribute('href'));
    var template = trovaTemplate(scheda, handle);
    if (!template || !template.content.firstElementChild) return false;

    scheda.setAttribute('data-cambio-in-corso', '');
    var ordine = Array.prototype.map.call(
      scheda.querySelectorAll(SEL_PALLINO),
      function (a) { return handleDaUrl(a.getAttribute('href')); }
    );
    var avevaFocus = scheda.contains(document.activeElement);

    precarica(template).then(function () {
      if (!scheda.isConnected) return;
      var nuova = template.content.firstElementChild.cloneNode(true);
      nuova.removeAttribute('reveal-on-scroll');

      var altri = Array.prototype.slice.call(scheda.querySelectorAll('template.scheda-fratello'))
        .filter(function (t) { return t !== template; });
      altri.push(schedaInTemplate(scheda));
      var contenitore = nuova.querySelector('.product-card__info') || nuova;
      altri.forEach(function (t) { contenitore.appendChild(t); });

      riallineaPallini(nuova, ordine);
      scheda.replaceWith(nuova);

      if (avevaFocus) {
        var selezionato = nuova.querySelector(SEL_PALLINO + '.is-selected');
        if (selezionato) selezionato.focus({ preventScroll: true });
      }
    });
    return true;
  }

  document.addEventListener('click', function (e) {
    var pallino = e.target && e.target.closest ? e.target.closest(SEL_PALLINO) : null;
    if (!pallino) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var scheda = pallino.closest('product-card');
    if (!scheda) return;
    if (pallino.classList.contains('is-selected') || scheda.hasAttribute('data-cambio-in-corso')) {
      e.preventDefault();
      return;
    }
    if (cambiaColore(scheda, pallino)) e.preventDefault();
  });

  document.addEventListener('pointerover', function (e) {
    var pallino = e.target && e.target.closest ? e.target.closest(SEL_PALLINO) : null;
    if (!pallino || pallino.classList.contains('is-selected') || pallino.hasAttribute('data-precaricato')) return;
    var scheda = pallino.closest('product-card');
    var template = scheda && trovaTemplate(scheda, handleDaUrl(pallino.getAttribute('href')));
    if (!template) return;
    pallino.setAttribute('data-precaricato', '');
    precarica(template);
  }, { passive: true });
})();

/* ----------------------------------------------------------------------------------------------
   UNA SCHEDA PER FAMIGLIA: il completamento esatto, oltre la singola pagina
   Il Liquid di snippets/griglia-una-per-famiglia.liquid (main-collection e main-search) salta i fratelli gia' comparsi
   nella STESSA pagina, ma non vede le pagine precedenti e non sa quante famiglie ci sono in tutta la
   collezione. Questo modulo chiude i due buchi:
   1. se la griglia ha piu' di una pagina, chiede a sections/conta-famiglie-d5.liquid (via Section
      Rendering API, stesso URL quindi stessi filtri e ordinamento) l'ordine dell'intera collezione,
      250 prodotti per richiesta, e toglie dalla pagina corrente le schede dei colori la cui famiglia
      e' gia' comparsa prima;
   2. scrive nel contatore ("N prodotti" nella collezione, "N risultati" nella ricerca) il numero
      di famiglie invece che di colori. Su una pagina sola non serve nessuna richiesta: le famiglie
      sono le schede stampate.
   Gli attributi data-pagine / data-prodotti / data-prodotti-pagina stanno sul <product-list> e li
   scrive il Liquid delle due sezioni; se mancano (griglia "solo immagini"), il modulo non fa nulla.
   Il modulo riparte quando Prestige sostituisce la sezione (filtri, ordinamento, cambio pagina).
   ---------------------------------------------------------------------------------------------- */
(function () {
  'use strict';

  var SEL_SEZIONE = '.shopify-section--main-collection, .shopify-section--main-search';
  var SEZIONE_CONTA = 'conta-famiglie-d5';

  function trovaContatore(sezione) {
    return sezione.querySelector('.collection-toolbar__products-count')
      || sezione.querySelector('.section-header p');
  }

  function scriviContatore(el, n) {
    if (!el || typeof n !== 'number' || n < 0) return;
    var testo = el.textContent;
    var vecchio = (testo.match(/\d[\d.,\xa0]*/) || [null])[0];
    if (vecchio === null || vecchio === String(n)) return;
    el.textContent = testo.replace(vecchio, String(n));
    /* nella ricerca anche il titolo della scheda del browser porta il numero ("Ricerca: 28 risultati...") */
    if (document.title.indexOf(vecchio) >= 0) document.title = document.title.replace(vecchio, String(n));
  }

  function leggiJson(html) {
    var m = html.match(/<script[^>]*data-conta-famiglie[^>]*>([\s\S]*?)<\/script>/);
    if (!m) return null;
    try { return JSON.parse(m[1]); } catch (_) { return null; }
  }

  function ordineCompleto() {
    var url = new URL(location.href);
    url.searchParams.set('section_id', SEZIONE_CONTA);
    var visti = Object.create(null);
    var nascosti = Object.create(null);
    var quantiNascosti = 0;
    var prodotti = 0;

    function pagina(n) {
      url.searchParams.set('page', String(n));
      return fetch(url.toString(), { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var dati = leggiJson(html);
          if (!dati) return null;
          prodotti = dati.prodotti;
          (dati.ordine || []).forEach(function (riga) {
            var handle = riga[0];
            var famiglia = riga[1] || [];
            if (visti[handle]) {
              if (!nascosti[handle]) { nascosti[handle] = true; quantiNascosti++; }
              return;
            }
            famiglia.forEach(function (h) { visti[h] = true; });
          });
          if (n < dati.pagine && n < 40) return pagina(n + 1);
          return { nascosti: nascosti, quanti: quantiNascosti, prodotti: prodotti };
        });
    }
    return pagina(1);
  }

  function completa(sezione) {
    var lista = sezione.querySelector('product-list[data-pagine]');
    if (!lista) return;
    var chiave = location.search;
    if (lista.getAttribute('data-famiglie-fatte') === chiave) return;
    lista.setAttribute('data-famiglie-fatte', chiave);

    var pagine = parseInt(lista.getAttribute('data-pagine') || '1', 10);
    var prodotti = parseInt(lista.getAttribute('data-prodotti') || '0', 10);
    var prodottiPagina = parseInt(lista.getAttribute('data-prodotti-pagina') || '0', 10);
    var contatore = trovaContatore(sezione);

    if (pagine <= 1) {
      var schede = lista.querySelectorAll('product-card').length;
      scriviContatore(contatore, prodotti - (prodottiPagina - schede));
      return;
    }

    ordineCompleto().then(function (esito) {
      if (!esito || !lista.isConnected) return;
      lista.querySelectorAll('product-card[handle]').forEach(function (scheda) {
        if (esito.nascosti[scheda.getAttribute('handle')]) scheda.remove();
      });
      scriviContatore(contatore, esito.prodotti - esito.quanti);
    }).catch(function () {});
  }

  function avvia() {
    document.querySelectorAll(SEL_SEZIONE).forEach(completa);
  }

  /* Prestige, cambiando filtri/ordinamento/pagina, sostituisce la sezione E aggiorna l'URL: il modulo
     riparte 300 ms dopo l'ULTIMO dei due eventi, cosi' legge sempre l'URL definitivo (una richiesta
     fatta con l'URL vecchio toglierebbe le schede sbagliate). */
  var attesa = null;
  function avviaPresto() {
    clearTimeout(attesa);
    attesa = setTimeout(avvia, 300);
  }

  /* Solo dove c'e' una griglia (collezione o ricerca) e mai nell'editor del tema: nelle altre pagine
     il modulo non registra niente, ne' osservatori ne' agganci alla history. */
  if (!document.querySelector(SEL_SEZIONE)) return;
  if (window.Shopify && window.Shopify.designMode) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }

  ['pushState', 'replaceState'].forEach(function (metodo) {
    var originale = history[metodo];
    if (typeof originale !== 'function') return;
    history[metodo] = function () {
      var esito = originale.apply(this, arguments);
      avviaPresto();
      return esito;
    };
  });
  window.addEventListener('popstate', avviaPresto);

  new MutationObserver(function (mutazioni) {
    for (var i = 0; i < mutazioni.length; i++) {
      var aggiunti = mutazioni[i].addedNodes;
      for (var j = 0; j < aggiunti.length; j++) {
        var n = aggiunti[j];
        if (n.nodeType === 1 && (n.matches('product-list, .shopify-section, .collection__main') || n.querySelector('product-list'))) {
          avviaPresto();
          return;
        }
      }
    }
  }).observe(document.getElementById('main') || document.documentElement, { childList: true, subtree: true });
})();

/* ----------------------------------------------------------------------------------------------
   GALLERIA NELLA SCHEDA: frecce in hover (mouse) e puntini; lo swipe su touch e' scroll nativo
   Markup: snippets/scheda-galleria.liquid (pista .scheda-galleria__pista con una slide per foto,
   frecce e puntini fuori dal link). CSS: assets/scheda-galleria.css.
   - Il crossfade in hover di Prestige mostra la seconda foto sopra la pista finche' la galleria non e'
     "attiva": al primo click su una freccia la scheda riceve data-galleria-attiva (il CSS spegne la
     secondaria), la pista salta subito alla foto 2 (quella che l'utente sta gia' vedendo) e poi si
     muove di uno nella direzione chiesta. Al mouseleave si torna alla foto 1 e all'hover normale.
   - I PUNTINI DICONO LA FOTO VISIBILE, non la posizione della pista (17/09/2026): con il mouse sopra
     il crossfade mostra la foto 2, quindi il puntino acceso e' il 2; al mouseleave torna il 1. Prima
     restava acceso il 1 durante l'hover e al primo click saltava da 1 a 3, perche' la pista partiva
     dalla foto 2. Vale solo con puntatore fine, galleria non attiva e pista sulla foto 1: da touch,
     da tastiera e a galleria attiva i puntini seguono la pista come sempre.
   - PUNTINI SUL PIXEL INTERO (17/09/2026): le schede hanno larghezze frazionarie (287,25px...), quindi
     il contenitore dei puntini finisce a offset diversi da scheda a scheda e l'anti-aliasing disegna
     cerchi piu' o meno marcati (misurato: stesso 8px di geometria, 15% di inchiostro in meno a offset
     .8). allineaPunti sposta il contenitore della sola parte frazionaria, cosi' i cerchi si disegnano
     allo stesso offset ovunque. Ricalcolato all'avvio, al resize e allo scroll della pagina (con
     attesa), e a ogni mouseenter sulla scheda.
   - Le foto oltre la prima sono lazy: al primo uso (freccia, trackpad o dito) vengono messe eager.
   - I puntini seguono lo scroll della pista (anche lo swipe), con un aggiornamento per frame.
   - Tutto in delega sul document: vale anche per le schede inserite dopo (cambio colore, filtri).
   - HOST: la scheda in griglia (<product-card>) oppure qualsiasi elemento con data-galleria-host: lo usano
     la riga del carrello a scomparsa e la sua foto a tutto schermo (snippets/carrello-riga.liquid,
     assets/carrello.js). Il ritorno alla foto 1 al mouseleave vale solo per le schede in griglia.
   ---------------------------------------------------------------------------------------------- */
(function () {
  'use strict';

  var SEL_FRECCIA = '.scheda-galleria__freccia';
  var SEL_PISTA = '.scheda-galleria__pista';
  var SEL_PUNTI = '.scheda-galleria__punti';
  var SEL_HOST = 'product-card, [data-galleria-host]';
  var MOUSE = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };

  function pistaDi(scheda) { return scheda.querySelector(SEL_PISTA); }

  function indiceDi(pista) {
    var w = pista.clientWidth || 1;
    return Math.max(0, Math.min(pista.children.length - 1, Math.round(pista.scrollLeft / w)));
  }

  function caricaTutte(pista) {
    if (pista.hasAttribute('data-caricata')) return;
    pista.setAttribute('data-caricata', '');
    pista.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }

  function aggiornaPunti(scheda, idx) {
    scheda.querySelectorAll('.scheda-galleria__punto').forEach(function (p, i) {
      p.classList.toggle('is-active', i === idx);
    });
  }

  /* porta il contenitore dei puntini sul pixel fisico intero: translate della sola parte frazionaria */
  function allineaPunti(punti) {
    punti.style.transform = '';
    var r = punti.getBoundingClientRect();
    if (!r.width) return;
    var dpr = window.devicePixelRatio || 1;
    var fx = ((r.left * dpr) % 1 + 1) % 1;
    var fy = ((r.top * dpr) % 1 + 1) % 1;
    if (fx < 0.02 && fy < 0.02) return;
    punti.style.transform = 'translate(' + (-fx / dpr).toFixed(3) + 'px,' + (-fy / dpr).toFixed(3) + 'px)';
  }

  function allineaTutti() {
    document.querySelectorAll(SEL_PUNTI).forEach(allineaPunti);
  }

  function vaiA(pista, idx, morbido) {
    pista.scrollTo({ left: idx * pista.clientWidth, behavior: morbido ? 'smooth' : 'auto' });
  }

  function attiva(scheda, pista) {
    if (scheda.hasAttribute('data-galleria-attiva')) return false;
    scheda.setAttribute('data-galleria-attiva', '');
    caricaTutte(pista);
    return true;
  }

  /* vero quando, con il mouse sopra, e' il crossfade di Prestige a decidere cosa si vede (foto 2) */
  function crossfadeComanda(scheda, pista) {
    return MOUSE.matches
      && !scheda.hasAttribute('data-galleria-attiva')
      && pista.children.length > 1
      && indiceDi(pista) === 0
      && !!scheda.querySelector('.product-card__image--secondary');
  }

  document.addEventListener('click', function (e) {
    var freccia = e.target && e.target.closest ? e.target.closest(SEL_FRECCIA) : null;
    if (!freccia) return;
    e.preventDefault();
    var scheda = freccia.closest(SEL_HOST);
    var pista = scheda && pistaDi(scheda);
    if (!pista) return;
    var n = pista.children.length;
    if (n < 2) return;
    var dir = parseInt(freccia.getAttribute('data-galleria-dir'), 10) || 1;
    var idx = indiceDi(pista);
    /* con il mouse sopra, il crossfade di Prestige sta gia' mostrando la foto 2: si riparte da li'.
       Da tastiera (freccia a fuoco senza hover) la foto visibile e' la 1, e si parte da quella. */
    var daCrossfade = crossfadeComanda(scheda, pista) && scheda.matches(':hover');
    if (attiva(scheda, pista) && daCrossfade) {
      idx = 1;
      vaiA(pista, 1, false);
    }
    var nuovo = (idx + dir + n) % n;
    vaiA(pista, nuovo, true);
    aggiornaPunti(scheda, nuovo);
  });

  /* mouse sopra una scheda in griglia: puntini sul pixel intero e, se il crossfade mostra la foto 2,
     puntino acceso sul 2 */
  document.addEventListener('mouseenter', function (e) {
    var scheda = e.target;
    if (!scheda || scheda.nodeType !== 1 || !scheda.matches || !scheda.matches('product-card')) return;
    var pista = pistaDi(scheda);
    if (!pista) return;
    var punti = scheda.querySelector(SEL_PUNTI);
    if (punti) allineaPunti(punti);
    if (!crossfadeComanda(scheda, pista)) return;
    aggiornaPunti(scheda, 1);
  }, true);

  document.addEventListener('mouseleave', function (e) {
    var scheda = e.target;
    if (!scheda || scheda.nodeType !== 1 || !scheda.matches || !scheda.matches('product-card')) return;
    var pista = pistaDi(scheda);
    if (!pista) return;
    if (scheda.hasAttribute('data-galleria-attiva')) {
      scheda.removeAttribute('data-galleria-attiva');
      vaiA(pista, 0, false);
    }
    /* a galleria non attiva la pista e' gia' sulla foto 1: si spegne solo il puntino 2 acceso dall'hover */
    aggiornaPunti(scheda, 0);
  }, true);

  var inAttesa = [];
  document.addEventListener('scroll', function (e) {
    var pista = e.target;
    if (!pista || pista.nodeType !== 1 || !pista.classList || !pista.classList.contains('scheda-galleria__pista')) return;
    if (inAttesa.indexOf(pista) >= 0) return;
    inAttesa.push(pista);
    requestAnimationFrame(function () {
      inAttesa.splice(inAttesa.indexOf(pista), 1);
      var scheda = pista.closest(SEL_HOST);
      if (!scheda) return;
      var idx = indiceDi(pista);
      if (idx > 0) attiva(scheda, pista);
      aggiornaPunti(scheda, idx);
    });
  }, true);

  document.addEventListener('touchstart', function (e) {
    var pista = e.target && e.target.closest ? e.target.closest(SEL_PISTA) : null;
    if (pista) caricaTutte(pista);
  }, { passive: true, capture: true });

  /* allineamento al pixel: all'avvio, al resize e allo scroll della pagina, con attesa */
  var attesaAllinea = null;
  function allineaPresto() {
    clearTimeout(attesaAllinea);
    attesaAllinea = setTimeout(allineaTutti, 150);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', allineaTutti);
  } else {
    allineaTutti();
  }
  window.addEventListener('load', allineaTutti);
  window.addEventListener('resize', allineaPresto);
  window.addEventListener('scroll', allineaPresto, { passive: true });
})();